__turbopack_context__.v({
  "alignItems-bottom": "Grid-module-scss-module__kV6fQq__alignItems-bottom",
  "alignItems-center": "Grid-module-scss-module__kV6fQq__alignItems-center",
  "alignItems-top": "Grid-module-scss-module__kV6fQq__alignItems-top",
  "col-count-1": "Grid-module-scss-module__kV6fQq__col-count-1",
  "col-count-10": "Grid-module-scss-module__kV6fQq__col-count-10",
  "col-count-11": "Grid-module-scss-module__kV6fQq__col-count-11",
  "col-count-12": "Grid-module-scss-module__kV6fQq__col-count-12",
  "col-count-2": "Grid-module-scss-module__kV6fQq__col-count-2",
  "col-count-3": "Grid-module-scss-module__kV6fQq__col-count-3",
  "col-count-4": "Grid-module-scss-module__kV6fQq__col-count-4",
  "col-count-5": "Grid-module-scss-module__kV6fQq__col-count-5",
  "col-count-6": "Grid-module-scss-module__kV6fQq__col-count-6",
  "col-count-7": "Grid-module-scss-module__kV6fQq__col-count-7",
  "col-count-8": "Grid-module-scss-module__kV6fQq__col-count-8",
  "col-count-9": "Grid-module-scss-module__kV6fQq__col-count-9",
  "grid": "Grid-module-scss-module__kV6fQq__grid",
});
